import { render, staticRenderFns } from "./VslClass.vue?vue&type=template&id=9b289990&"
import script from "./VslClass.vue?vue&type=script&lang=js&"
export * from "./VslClass.vue?vue&type=script&lang=js&"
import style0 from "./VslClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VslClass.vue"
export default component.exports